import { Button } from "@/common/ui/button";

import type { TimeRange } from "./types";

interface TimeRangeSelectorProps {
  value: TimeRange;
  onChange: (range: TimeRange) => void;
}

const TIME_RANGES: { label: string; value: TimeRange }[] = [
  { label: "1h", value: "1h" },
  { label: "24h", value: "24h" },
  { label: "7d", value: "7d" },
  { label: "30d", value: "30d" },
];

export function TimeRangeSelector({ value, onChange }: TimeRangeSelectorProps): React.ReactElement {
  return (
    <div
      data-testid="time-range-selector"
      role="group"
      aria-label="Time range"
      className="flex gap-1"
    >
      {TIME_RANGES.map((range) => (
        <Button
          key={range.value}
          data-testid={`time-range-${range.value}`}
          variant={value === range.value ? "default" : "outline"}
          size="sm"
          aria-pressed={value === range.value}
          onClick={() => onChange(range.value)}
        >
          {range.label}
        </Button>
      ))}
    </div>
  );
}
